import React from 'react';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import ExternalLink from 'src/components/common/external-link';
import Logo from '../logo';

import globalStore from 'src/stores/global-store';

import {
  ABOUT_LINK,
  CNAME,
  HEADER_PHONE,
  HEADER_PHONE_TEXT,
  IS_HEBREW,
  IS_LOGO_TEXT_SEPARATED,
  LOCALES,
  LogoSize,
  WITH_CUSTOM_LOGO_HEIGHT,
  WITH_PHONE,
} from 'src/constants';
import { formatHebrewPhone } from 'src/utils';

import './header.scss';

const Header = observer(() => {
  const { cemeteryName } = globalStore;

  return (
    <header
      className={classNames(
        'header',
        IS_HEBREW && 'header_hebrew',
        (WITH_CUSTOM_LOGO_HEIGHT || IS_LOGO_TEXT_SEPARATED) && 'header_with-custom-logo-height',
        WITH_PHONE && 'header_hebrew_with-phone'
      )}
    >
      <div className={classNames('header__wrapper', WITH_PHONE && 'header__wrapper_with-phone')}>
        <a
          className="header__logo-link"
          href={CNAME}
          title={`${cemeteryName} / ${LOCALES.SEARCH_BURIAL_RECORDS}`}
        >
          <Logo size={LogoSize.MEDIUM} />
        </a>

        <a
          className="header__small-logo-link"
          href={CNAME}
          title={`${cemeteryName} / ${LOCALES.SEARCH_BURIAL_RECORDS}`}
        >
          <Logo size={LogoSize.SMALL} />
        </a>

        {WITH_PHONE && (
          <>
            <div className="header__phone-block">
              <ExternalLink
                className="header__phone-link"
                href={`tel:${HEADER_PHONE}`}
                title={LOCALES.PHONE_NUMBER}
              >
                {formatHebrewPhone(HEADER_PHONE)}
              </ExternalLink>
              {HEADER_PHONE_TEXT && <div className="header__phone-text">{HEADER_PHONE_TEXT}</div>}
            </div>
            <div className="header__cemetery-block">
              <ExternalLink
                className="header__cemetery-link"
                href={ABOUT_LINK || '/'}
                title={LOCALES.WEBSITE}
              >
                {LOCALES.WEBSITE}
              </ExternalLink>
            </div>
          </>
        )}
      </div>
    </header>
  );
});

export default Header;
